// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1tfZI","newExpiryDate":"styles_newExpiryDate__13YrO","footer":"styles_footer__3yREP"};